import type { BrowserAuthOptions } from "@azure/msal-browser";
import type { CirclemsConfig } from "~/types/circlemsConfig";
import { defineAppConfig } from "#imports";

const configProIntwcAPI: CirclemsConfig = {
  CIRCLE_MS_BASE_URL: "https://circle.ms",
  CIRCLE_MS_PORTAL_BASE_URL: "https://portal.circle.ms",
  CIRCLE_MS_WEB_CATALOG_BASE_URL: "https://webcatalog.circle.ms",
  CIRCLE_MS_AUTH2_BASE_URL: "https://auth2.circle.ms",
  CIRCLE_MS_DOCS_BASE_URL: "https://docs.circle.ms",
  CIRCLE_MS_AUTH_COOKIE_KEY: ".ASPXAUTH",
  CIRCLE_MS_AUTH_COOKIE_DOMAIN: ".circle.ms",
  COMIKET_URI_BASE_URL: "https://www.comiket.co.jp",
  V4G_POP_JS_URL: "https://pay.veritrans.co.jp/pop/v1/javascripts/pop.js"
};
const configProStgIntwcAPI: CirclemsConfig = {
  CIRCLE_MS_BASE_URL: "https://circle.ms",
  CIRCLE_MS_PORTAL_BASE_URL: "https://portal.circle.ms",
  CIRCLE_MS_WEB_CATALOG_BASE_URL: "https://webcatalog.circle.ms",
  CIRCLE_MS_AUTH2_BASE_URL: "https://auth2.circle.ms",
  CIRCLE_MS_DOCS_BASE_URL: "https://docs.circle.ms",
  CIRCLE_MS_AUTH_COOKIE_KEY: ".ASPXAUTH",
  CIRCLE_MS_AUTH_COOKIE_DOMAIN: ".circle.ms",
  COMIKET_URI_BASE_URL: "https://www.comiket.co.jp",
  V4G_POP_JS_URL: "https://pay.veritrans.co.jp/pop/v1/javascripts/pop.js"
};
const configSTIntwcAPI: CirclemsConfig = {
  CIRCLE_MS_BASE_URL: "https://st.circle.ms",
  CIRCLE_MS_PORTAL_BASE_URL: "https://portal.st.circle.ms",
  CIRCLE_MS_WEB_CATALOG_BASE_URL: "https://webcatalog.st.circle.ms",
  CIRCLE_MS_AUTH2_BASE_URL: "https://auth2.st.circle.ms",
  CIRCLE_MS_DOCS_BASE_URL: "https://docs.circle.ms",
  CIRCLE_MS_AUTH_COOKIE_KEY: ".ST_ASPXAUTH",
  CIRCLE_MS_AUTH_COOKIE_DOMAIN: ".st.circle.ms",
  COMIKET_URI_BASE_URL: "https://www.comiket.co.jp",
  V4G_POP_JS_URL: "https://pay.veritrans.co.jp/pop/v1/javascripts/pop.js"
};
const configDev: CirclemsConfig = {
  CIRCLE_MS_BASE_URL: "https://st.circle.ms",
  CIRCLE_MS_PORTAL_BASE_URL: "https://portal.st.circle.ms",
  CIRCLE_MS_WEB_CATALOG_BASE_URL: "https://webcatalog.st.circle.ms",
  CIRCLE_MS_AUTH2_BASE_URL: "https://auth2.st.circle.ms",
  CIRCLE_MS_DOCS_BASE_URL: "https://docs.circle.ms",
  CIRCLE_MS_AUTH_COOKIE_KEY: ".ST_ASPXAUTH",
  CIRCLE_MS_AUTH_COOKIE_DOMAIN: ".st.circle.ms",
  COMIKET_URI_BASE_URL: "https://www.comiket.co.jp",
  V4G_POP_JS_URL: "https://pay.veritrans.co.jp/pop/v1/javascripts/pop.js"
};

// シングルページ アプリケーション: アプリの登録 https://learn.microsoft.com/ja-jp/entra/identity-platform/scenario-spa-app-registration
const browserAuthOptionsPro: BrowserAuthOptions = {
  clientId: "db6cd975-64cb-47a1-b19e-99a4024118e6",
  authority: "https://procirclemsb2c.b2clogin.com/procirclemsb2c.onmicrosoft.com/B2C_1_normal",
  // B2C 用に必須の設定
  knownAuthorities: ["procirclemsb2c.b2clogin.com"],
  redirectUri: "/auth/msal" // EntraID からの戻り先は限定しなければならない。ログイン前の path は session として保存
};

const browserAuthOptionsSt: BrowserAuthOptions = {
  clientId: "81f4dbe4-225e-4d57-93a1-363f6e2d3ef0",
  authority: "https://stcirclemsb2c.b2clogin.com/stcirclemsb2c.onmicrosoft.com/B2C_1_normal",
  // B2C 用に必須の設定
  knownAuthorities: ["stcirclemsb2c.b2clogin.com"],
  redirectUri: "/auth/msal" // EntraID からの戻り先は限定しなければならない。ログイン前の path は session として保存
};

const browserAuthOptionsDev: BrowserAuthOptions = {
  clientId: "2936456f-5cbe-43d8-b47d-15b17a911751",
  authority: "https://devcirclemsb2c.b2clogin.com/devcirclemsb2c.onmicrosoft.com/B2C_1_normal",
  // B2C 用に必須の設定
  knownAuthorities: ["devcirclemsb2c.b2clogin.com"],
  redirectUri: "/auth/msal" // EntraID からの戻り先は限定しなければならない。ログイン前の path は session として保存
  // EntraID の場合は authority: "https://login.microsoftonline.com/2dd61136-6f39-4480-98df-d77b834fed1a",
  // redirectUri: config.public.redirectUri, // By default, MSAL is configured to set the redirect URI to the current page that it is running on.
  // postLogoutRedirectUri: config.public.postLogoutRedirectUri,
  // navigateToLoginRequestUrl: true, // If true, will navigate back to the original request location before processing the authorization code response. この値は既定で true
};

export default defineAppConfig({
  circlemsConfigDict: {
    // runtimeConfig.public.appEnv によって選択するロジックは
    // client-app/src/composables/config/useCirclemsConfig.ts にある
    // 上の登場順に合わせる dev が最後なのは 末尾カンマ の差分をなくすため
    proIntwcAPI: configProIntwcAPI,
    proStgIntwcAPI: configProStgIntwcAPI,
    stIntwcAPI: configSTIntwcAPI,
    dev: configDev
  },
  browserAuthOptionsDict: {
    pro: browserAuthOptionsPro,
    st: browserAuthOptionsSt,
    dev: browserAuthOptionsDev,
  }
});
